<template>
  <b-modal body-class="raffle-spinner-modal" :id="`raffle-spinner-${leaderboardID}`" lazy hide-footer title="Draw Winner">
    <div v-if="users">
      <span class="winner-box" :class="{ 'primary-background-color': isWinnerPicked, 'secondary-background-color': !winner }">
        <button v-if="!winner" type="button" class="btn btn-primary btn-lg" @click="drawWinner">Draw Winner</button>
        <span v-if="winner && isWinnerPicked" class="title">The winner is</span>
        <span v-if="winner" class="name">{{winner.fullName}}</span>
        <span v-if="winner && isWinnerPicked" class="email">{{winner.emailAddress}}</span>
      </span>
    </div>
  </b-modal>
</template>

<script>
import gql from 'graphql-tag';

export default {
  name: 'RaffleSpinnerModal',
  props: {
    leaderboardID: String
  },
  data() {
    return {
      winner: null,
      isWinnerPicked: false
    };
  },
  apollo: {
    users: {
      query: gql`
        query LeaderboardUsersQuery($leaderboardID: ID!) {
          company {
            id
            leaderboard(where: {
              id: $leaderboardID
              status: ACTIVE
            }) {
              id
              userScores {
                edges {
                  entry { id, fullName, emailAddress }
                  total
                }
              }
            }
          }
        }
      `,
      variables() {
        const { leaderboardID } = this;
        return { leaderboardID };
      },
      fetchPolicy: 'cache-and-network',
      update: ({ company: { leaderboard: { userScores: { edges } } } }) => (
        edges.map(
          ({ entry: { id, fullName, emailAddress }, total }) => ({ id, fullName, emailAddress, total })
        ).filter(user => (user.total > 0))
      ),
      error(err) {
        this.err = `${err}`;
      },
    },
  },
  methods: {
    drawWinner() {
      const interval = setInterval(() => {
        this.winner = this.users[Math.round((Math.random() * (this.users.length - 1)))];
      }, 150);
      setTimeout(() => {
        clearInterval(interval);
        const numOfTickets = this.users.reduce((sum, user) => (sum + user.total), 0);
        const winnerTicket = Math.round((Math.random() * numOfTickets));
        this.users.reduce((sum, user) => {
          if (sum < winnerTicket && winnerTicket <= sum + user.total) {
            this.winner = user;
          }
          return sum + user.total;
        }, 0);
        this.isWinnerPicked = true;
      }, 5000);
    }
  }
};
</script>

<style lang="scss">
.raffle-spinner-modal {
  padding: 0;
  overflow: hidden;

  .winner-box {
    display: flex;
    width: 100%;
    height: 140px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: #273c75;
    text-align: center;
    color: #fff;

    .name {
      font-size: 26px;
      font-weight: 700;
      line-height: 42px;
    }

    .title, .email {
      font-size: 16px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/modals/raffle-spinner.vue